/**
 * Candidate Status Constants - As per requirements
 */

export const CANDIDATE_STATUS_OPTIONS = [
    'New Lead',        // Just added, never spoken to
    'Active',          // Spoken to, negotiated, available for submissions
    'Unavailable',     // Hired by competitor, out of market
    'Hired',           // Hired internally by RTS (final state)
    'DNU/DNW'          // Do Not Use/Do Not Work - red flags
];

// Note: Archive is NOT included as per requirements

export const EMPLOYMENT_PREFERENCE_OPTIONS = [
    'Full-Time Employee',
    'Contractor',
    'Corp-to-Corp (C2C)',
    'Direct Hire',
    'Contract',
    'Contract-to-Hire'
];

export const EMPLOYEE_TYPE_OPTIONS = [
    'W2 Hourly',
    'W2 Salary',
    '1099',
    'Corp-to-Corp',
    'Individual Corp-to-Corp',
    'Internal',
    'Internal Billable'
];

export const YES_NO_NA_OPTIONS = ['Yes', 'No', 'Not Applicable'];

export const PHONE_TYPE_OPTIONS = ['iPhone', 'Android', 'Other'];

export const WORKDAY_SYNC_STATUS_OPTIONS = [
    'Ready to Sync',
    'Sync Failed',
    'Synced'
];

export const SCHEDULE_NEXT_ACTION_OPTIONS = [
    'None',
    'Add Submission',
    'Add Client Submission'
];

export const PREFIX_OPTIONS = ['Mr.', 'Mrs.', 'Ms.', 'Dr.', 'Prof.'];

export const SUFFIX_OPTIONS = ['Junior', 'Senior', 'ESQ', 'II', 'III', 'IV'];

export const GENDER_OPTIONS = ['Male', 'Female', 'Other'];
